import { usePlanningStore } from '@planning/AppProvider'
import { useVesselVisitBreadcrumbs } from '@planning/hooks/useVesselVisitBreadcrumbs'
import { INonNumericReleaseItem } from '@planning/rt-stores/nnrOrder/NnrOrderItem'
import { useTranslate } from '@tolgee/react'
import { PATHS } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { FC, useMemo } from 'react'
import { useLocation, useParams } from 'react-router'
import { ReleaseDetailsViewStore } from '../../../Stores/ReleaseDetailsViewStore'
import { ReleaseDetailsHeader } from '../../molecules/ReleaseDetailsHeader'
import { NonNumericReleaseDetailsOptions } from './NonNumericReleaseDetailsOptions'

type Props = {
  viewStore: ReleaseDetailsViewStore
  nnrOrder: INonNumericReleaseItem
}

export const NonNumericReleaseDetailsHeader: FC<Props> = observer(({ nnrOrder, viewStore }) => {
  const { t } = useTranslate()
  const { pathname } = useLocation()
  const { id: vesselVisitId } = useParams<{ id?: string }>()

  const { vesselVisitItemStore } = usePlanningStore()
  const vesselVisit = vesselVisitId
    ? vesselVisitItemStore.getById(Number(vesselVisitId))
    : undefined

  const { breadcrumbs: vesselBreadcrumbs } = useVesselVisitBreadcrumbs(vesselVisit)

  const { shippingLine, referenceNumber } = nnrOrder.data
  const identifier = shippingLine ? `${shippingLine}-${referenceNumber}` : referenceNumber

  const isVesselVisitContext = pathname.includes(PATHS.visits.vesselVisits.url)

  const breadCrumbs = useMemo(() => {
    if (isVesselVisitContext && vesselBreadcrumbs?.length > 0) {
      return vesselBreadcrumbs
    }

    return [
      {
        label: t(PATHS.orders.nonNumericReleases.title, 'Non-numeric releases'),
        route: PATHS.orders.nonNumericReleases.url,
      },
      {
        label: `${identifier}`,
      },
    ]
  }, [isVesselVisitContext, vesselBreadcrumbs, identifier, t])

  const title = t('nonNumericReleaseDetails', 'Non-numeric release details')

  return (
    <ReleaseDetailsHeader
      title={title}
      breadCrumbs={breadCrumbs}
      rightRenderOption={
        <NonNumericReleaseDetailsOptions nnrOrder={nnrOrder} viewStore={viewStore} />
      }
    />
  )
})
